import { toRoundedAmount } from '@shared/conversions'
import { LiquidityAssetStateWithBalancesCTO } from '@shared/ReservePlanCTO'

// // Copyright Open Trade Technology Ltd. 2023. All rights reserved.
export interface LiquidityAssetClassTestOutput {
  lytPoolBalance: string
  lytIssuerVaultBalance: string
  reserveTransferBalance: string
  lytIssuerVaultBalanceAfterActions: string
  lytPoolBalanceAfterActions: string
  reserveTransferBalanceAfterActions: string
  name: string
  symbol: string
}
export class LiquidityAssetClass {
  constructor(liquidityAssetCTO: LiquidityAssetStateWithBalancesCTO) {
    this.liquidityAssetCTO = liquidityAssetCTO

    this.uuid = liquidityAssetCTO.uuid
    this.isLytNative = liquidityAssetCTO.isLytNative
    this.chain = liquidityAssetCTO.chain
    this.chainId = liquidityAssetCTO.chainId
    this.address = liquidityAssetCTO.address
    this.depositAddress = liquidityAssetCTO.depositAddress
    this.symbol = liquidityAssetCTO.symbol
    this.name = liquidityAssetCTO.name
    this.decimals = liquidityAssetCTO.decimals
    this.exchangeRate = liquidityAssetCTO.exchangeRate
    this.timestamp = liquidityAssetCTO.timestamp
    this.reserveTransferAddress = liquidityAssetCTO.reserveTransferAddress
    this.lytIssuerVaultBalance = BigInt(liquidityAssetCTO.lytIssuerVaultBalance)
    this.lytPoolBalance = BigInt(liquidityAssetCTO.lytPoolBalance)
    this.reserveTransferBalance = BigInt(liquidityAssetCTO.reserveTransferBalance)

    this.lytIssuerVaultBalanceAfterActions = 0n
    this.lytPoolBalanceAfterActions = 0n
    this.reserveTransferBalanceAfterActions = 0n
  }
  uuid: string
  isLytNative: boolean
  chain: string
  chainId: number
  address: string
  depositAddress: string
  symbol: string
  name: string
  decimals: number
  exchangeRate: number
  timestamp: number
  reserveTransferAddress: string
  liquidityAssetCTO: LiquidityAssetStateWithBalancesCTO
  lytIssuerVaultBalance: bigint
  lytPoolBalance: bigint
  reserveTransferBalance: bigint
  lytIssuerVaultBalanceAfterActions: bigint
  lytPoolBalanceAfterActions: bigint
  reserveTransferBalanceAfterActions: bigint

  get testOutput(): LiquidityAssetClassTestOutput {
    return {
      lytPoolBalance: toRoundedAmount(this.lytPoolBalance),
      lytIssuerVaultBalance: toRoundedAmount(this.lytIssuerVaultBalance),
      reserveTransferBalance: toRoundedAmount(this.reserveTransferBalance),
      lytIssuerVaultBalanceAfterActions: toRoundedAmount(this.lytIssuerVaultBalanceAfterActions),
      lytPoolBalanceAfterActions: toRoundedAmount(this.lytPoolBalanceAfterActions),
      reserveTransferBalanceAfterActions: toRoundedAmount(this.reserveTransferBalanceAfterActions),
      name: this.name,
      symbol: this.symbol,
    }
  }
  toString(): string {
    const structuredOutput = this.testOutput
    return JSON.stringify(structuredOutput, null, 2)
  }
  [Symbol.for('nodejs.util.inspect.custom')](): string {
    return this.toString()
  }
}
